export const getRequestUrl = ( endpoint: string ) => {
    return process.env["REACT_APP_API_URL"] + ( endpoint[0] !== "/" ? "/" : "" ) + endpoint;
};